import { render, staticRenderFns } from "./RequestPartnershipPage.vue?vue&type=template&id=00b63af8&"
import script from "./RequestPartnershipPage.vue?vue&type=script&lang=js&"
export * from "./RequestPartnershipPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports